import { backendId } from '@/aws-config';
import { addOrgWsPrefix } from '.';

export const makeNameGlueCompatible = (name: string): string => {
  return name.toLowerCase().replace(/[^0-9a-z]/g, '_');
};

// COPIED TO `cypress/e2e/common.ts`
// https://docs.aws.amazon.com/redshift/latest/dg/r_names.html#r_names-standard-identifiers
export function makeNameSqlCompatible(name: string): string {
  return name.toLowerCase().replace(/[\s"]/g, '_');
}

export const isDevBackend = (): boolean => {
  return backendId !== 'wjvcybotv';
};

export const addBackendSuffix = (name: string): string => {
  if (backendId === 'wjvcybotv') return name;
  return `${name}@${backendId}`;
};

export const getUrlForViewDatasetTestData = (testUuid: string): string => {
  return addOrgWsPrefix(`/hub/datasets/test/${testUuid}/view/latest`);
};

export const getCognitoUsernameFromAuth0UserId = (auth0UserId: string): string => {
  return `auth0_${auth0UserId}`;
};
